import React from "react";
import { RouteObject } from "react-router-dom";
import { SUPPORTED_LANGUAGES } from "../../utils/languageRouting";
import Homepage from "../../Homepage2";
import RegistrationPage from "../../pages/RegistrationPage";
import LoginPage from "../../pages/LoginPage";
import KokobeoHomepages from "../../Menu/Homepage";
import ProfessionalDashboard from "../../pages/Main/Professional";
import TermsPage from "../../pages/Main/Terms";
import PrivacyPolicyPage from "../../pages/Main/Policy";
import { Contact } from "lucide-react";
import CookiesPolicyPage from "../../pages/Main/Cookies";
import Messages from "../../pages/Main/Messages";
import SubscriptionPlans from "../../Menu/plans";
import CreditsPage from "../../Menu/credits";
import ProjectsPage from "../../pages/Main/projects";
import HelpCenter from "../../Menu/help";
import AboutPage from "../../pages/Main/About";
import InternationalHomepage from "../../pages/Main/InternationalHomepage";
import PlumberRegistration from "../../pages/Main/PlumberRegistration";
import PlumberRequestForm from "../../pages/Main/PlumberRequestForm";
import LawyerRequestForm from "../../pages/Main/LawyerRequestForm";
import PlumberProfile from "../../pages/Main/PlumberProfile";
import ProfessionalPlumberProfile from "../../pages/Main/ProfessionalPlumberProfile";
import ProfessionalSearch from "../../pages/Main/ProfessionalSearch";
import ClientDashboard from "../../pages/Main/client";
import FreelancerDashboard from "../../pages/Main/professionalDashboard";
import ProHomepage from "../../pages/Main/Professional_Homepage";
import InternationalProfessional from "../../pages/Main/professional-international";
import InternationalProfessionalsPage from "../../pages/Main/International_Professionals_Page";
import LocalProfessionalsPage from "../../pages/Main/local_professionals";
import InternationalProfessionalsProfile from "../../pages/Main/int_professionals_profiles";
import WalletPage from "../../pages/Main/Wallet_Page";
import InternationalProfessionalRegistration from "../../pages/InternationalProfessionalRegistration";
import ProgressDashboard from "../../pages/progress";
import OrdersDashboard from "../../pages/myorders";
import OffersDashboard from "../../pages/MyOffers";
import ProposalsDashboard from "../../pages/MyProposals";
import SupportTickets from "../../pages/SupportTickets";
import WalletDashboard from "../../pages/WalletDashboard";
import WithdrawHistory from "../../pages/WithdrawalHistory";
import ProfileSettings from "../../pages/ProfessionalProfileSettings";
import ChangePassword from "../../pages/ChangePassword";
import DeleteAccount from "../../pages/DeleteAccount";
import MessagesAndVideoCall from "../../Menu/MessagesAndVideoCall";
import CMyProfile from "../../client/ClientProfile";
import ClientRegistration from "../../client/ClientRegistrationForm";
import ClientSettings from "../../client/ClientSettings";
import ProgressPage from "../../client/ClientProgress";
import PostJobPage from "../../client/PostaJob";
import MyJobsPage from "../../client/MyJobsPage";
import MyOrdersPage from "../../client/MyOrdersPage";
import MyOffersPage from "../../client/MyOffersPage";
import CMessagesAndVideoCall from "../../client/MessagesAndVideoCall";
import ClientWalletPage from "../../client/ClientWalletPage";
import ClientSupportTickets from "../../client/Client_Support_Tickets";
import NotificationsPage from "../../Menu/Notification";
import ContactPage from "../../Menu/Contact";
import AboutPage2 from "../../Menu/About";
import MessagesAndVideoCall2 from "../../Menu/MessagesAndVideoCall";
import AboutPage02 from "../../Menu2/About02";
import MessagesAndVideoCall02 from "../../Menu2/MessageAndVideoCall02";
import NotificationsPage02 from "../../Menu2/Notification02";
import ContactPage02 from "../../Menu2/Contact02";
import HelpCenter02 from "../../Menu2/Help02";
import VerifyAccount02 from "../../Menu2/verify02";
import SubscriptionPlans02 from "../../Menu2/plans02";
import CreditsPage02 from "../../Menu2/Credits02";
import LocalProfessionalProfile from "../../pages/Main/LocalProfessionalProfile";
import LocalProfessionalSettings from "../../pages/Main/LocalSettings";
import InviteFriends from "../../pages/InviteFriendsPage";
import CategoriesAndLocation from "../../pages/categories";
import ClientReviewsSection from "../../components/ui/ClientReviewsSection";
import ProfessionalReviewsSection from "../../components/ui/ProfessionalReviewsSection";

import ReportsPage from "../../client/reports";

import LocationManagement from "../../Admin/FORM MANAGEMENT/LocationManagement";
import Favorites from "../../pages/Favorites";
import Favorites2 from "../../pages/Favorites";
import Favorites22 from "../../pages/Favorites2";
import Favorites222 from "../../pages/Favorites22";
import ActiveJobs from "../../pages/Main/ActiveJobs";
import ClientProfile from "../client/components/ClientProfile1";
import ClientProfileSettings from "../client/components/ClientProfileSettings";
import MyProfile from "../professional/components/MyProfile";
import MySettings from "../professional/components/MySettings";
import VerifyAccount from "../main/components/menu/Verify";
import QuotesComponent from "../admin/components/QuotesComponent";
import AllJobsComponent from "../admin/components/AllJobsComponent";
import RefundRequestsPage from "../../pages/RefundRequestsPage";
import ClientInvoice from "../../pages/ClientInvoice";
import ProfessionalInvoice from "../../pages/ProfessionalInvoice";

// Base routes without language prefix
const baseRoutes: RouteObject[] = [
    { path: "/", element: <Homepage /> },
    { path: "/register", element: <RegistrationPage /> },
    { path: "/login", element: <LoginPage /> },
    { path: "/Homepage", element: <Homepage /> },
    { path: "/Terms", element: <TermsPage /> },
    // { path: "/Policy", element: <PrivacyPolicyPage /> },
    { path: "/Cookie", element: <CookiesPolicyPage /> },
    { path: "/projects", element: <ProjectsPage /> },
    { path: "/internationalhompage", element: <ProHomepage /> },
    { path: "/plumberregistration", element: <PlumberRegistration /> },
    { path: "/plumberrequestform", element: <PlumberRequestForm /> },
    { path: "/lawyerRequestForm", element: <LawyerRequestForm /> },
    { path: "/plumberprofile", element: <PlumberProfile /> },
    { path: "/professionalplumberprofile", element: <ProfessionalPlumberProfile /> },
    // { path: "/professionalSearch", element: <ProfessionalSearch /> },
    // { path: "/clients", element: <ClientDashboard /> },
    { path: "/Professionals", element: <FreelancerDashboard /> },
    { path: "/international-professionals", element: <AllJobsComponent jobType="international" /> },
    { path: "/jobs", element: <InternationalProfessionalsPage /> },
    { path: "/activejobs", element: <ActiveJobs /> },
    { path: "/professional", element: <AllJobsComponent /> },
    { path: "/local-professionals", element: <LocalProfessionalsPage /> },
    { path: "/professional-international", element: <InternationalProfessionalsProfile /> },
    { path: "/walletd", element: <WalletPage /> },
    { path: "/local/myprofile", element: <LocalProfessionalProfile /> },
    { path: "/local/settings", element: <LocalProfessionalSettings /> },
    { path: "/invite", element: <InviteFriends /> },
    { path: "/categories", element: <CategoriesAndLocation /> },
    { path: "/locationmanagement", element: <LocationManagement /> },
    { path: "/myprofile", element: <MyProfile /> },
    { path: "/Settings", element: <MySettings /> },
    { path: "/international_professional_registration", element: <InternationalProfessionalRegistration /> },
    { path: "/Progress", element: <ProgressDashboard /> },
    { path: "/myorders", element: <OrdersDashboard /> },
    { path: "/myoffers", element: <OffersDashboard /> },
    { path: "/myproposals", element: <ProposalsDashboard /> },
    { path: "/support", element: <SupportTickets /> },
    { path: "/wallet", element: <WalletDashboard /> },
    { path: "/withdrawalhistroy", element: <WithdrawHistory /> },
    { path: "/profilesettings", element: <ProfileSettings /> },
    { path: "/changepassword", element: <ChangePassword /> },
    { path: "/DeleteAccount", element: <DeleteAccount /> },
    { path: "/MessageAndVideoCall", element: <MessagesAndVideoCall2 /> },
    { path: "/client/registration", element: <ClientRegistration /> },
    { path: "/client/settings", element: <ClientSettings /> },
    { path: "/client/progress", element: <ProgressPage /> },
    { path: "/postajob", element: <PostJobPage /> },
    { path: "/myjobs", element: <MyJobsPage /> },
    // { path: "/client/myorders", element: <MyOrdersPage /> },
    { path: "/client/myoffers", element: <MyOffersPage /> },
    { path: "/client/MessageAndVideoCall", element: <MessagesAndVideoCall2 /> },
    { path: "/client/Wallet", element: <ClientWalletPage /> },
    { path: "/client/profilesettings", element: <ClientProfileSettings /> },
    { path: "/client/support", element: <ClientSupportTickets /> },
    { path: "/about", element: <AboutPage2 /> },
    { path: "/how-it-works", element: <KokobeoHomepages /> },
    { path: "/menu/messages", element: <MessagesAndVideoCall2 /> },
    { path: "/notifications", element: <NotificationsPage /> },
    { path: "/menu/contact", element: <ContactPage /> },
    { path: "/help", element: <HelpCenter /> },
    { path: "/client/profile", element: <ClientProfile /> },
    { path: "/client/reports", element: <ReportsPage /> },
    { path: "/verify", element: <VerifyAccount /> },
    { path: "/plans", element: <SubscriptionPlans /> },
    { path: "/credits", element: <CreditsPage /> },
    { path: "/client/myorders", element: <MyOrdersPage /> },
    { path: "/client/reviews", element: <ClientReviewsSection /> },
    { path: "/professional/reviews", element: <ProfessionalReviewsSection /> },
    { path: "/international/about", element: <AboutPage02 /> },
    { path: "/international/menu/messages", element: <MessagesAndVideoCall02 /> },
    { path: "/international/notifications", element: <NotificationsPage02 /> },
    { path: "/international/menu/contact", element: <ContactPage02 /> },
    { path: "/international/help", element: <HelpCenter02 /> },
    { path: "/international/verify", element: <VerifyAccount02 /> },
    { path: "/international/plans", element: <SubscriptionPlans02 /> },
    { path: "/international/credits", element: <CreditsPage02 /> },
    { path: "/client/favorites", element: <Favorites22 /> },
    { path: "/professional/favorites", element: <Favorites222 /> },
    { path: "/refund-requests", element: <RefundRequestsPage isClient={false} /> },
    { path: "/client/refund-requests", element: <RefundRequestsPage isClient={true} /> },
    { path: "/client/invoices", element: <ClientInvoice /> },
    { path: "/invoices", element: <ProfessionalInvoice /> },
    { path: "/client/profile/:userId", element: <ClientProfile /> },
    { path: "myprofile/:userId", element: <MyProfile /> },
];

/**
 * Create language-prefixed routes
 * Generates routes for each supported language (e.g., /it/professional, /es/clients)
 */
const createLanguagePrefixedRoutes = (routes: RouteObject[]): RouteObject[] => {
  const languagePrefixedRoutes: RouteObject[] = [];
  
  // Create routes for each language (except English which is the default)
  SUPPORTED_LANGUAGES.filter(lang => lang !== "en").forEach(lang => {
    routes.forEach(route => {
      if (route.path) {
        if (route.path === "/") {
          // For root path, add language prefix: /it, /es, etc.
          languagePrefixedRoutes.push({
            ...route,
            path: `/${lang}`,
          });
        } else {
          // Add language prefix: /it/professional
          languagePrefixedRoutes.push({
            ...route,
            path: `/${lang}${route.path}`,
          });
          
          // Also add language suffix for backward compatibility: /professional/it
          languagePrefixedRoutes.push({
            ...route,
            path: `${route.path}/${lang}`,
          });
        }
      }
    });
  });
  
  return languagePrefixedRoutes;
};

// Export both base routes and language-prefixed routes
const AppBackRoute: RouteObject[] = [
  ...baseRoutes,
  ...createLanguagePrefixedRoutes(baseRoutes),
];

export default AppBackRoute;